import { useContext, useMemo } from 'react';

// contexts
import { EditorContext } from '../../context/EditorContext';

import useVariantsByMessageContentIdQuery from 'hooks/variants/useVariantsByMessageContentIdQuery';

import { showWarningIconInEditor } from './helper';

export const useLockFormulaWarning = () => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const { data: alternateData } = useVariantsByMessageContentIdQuery(
        Number(formula?.id!),
    );

    const labelWarningComponents = useMemo<
        {
            [key: string]: boolean;
        }[]
    >(() => {
        if (alternateData && formula?.is_labeled_matching_enabled) {
            return showWarningIconInEditor(alternateData);
        }
        return [];
    }, [alternateData, formula]);

    const hasWarning = useMemo<boolean>(() => {
        return labelWarningComponents.some(
            (entry) => Object.values(entry)[0] === true,
        );
    }, [labelWarningComponents]);

    return {
        hasWarning,
        labelWarningComponents,
    };
};
